var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"top-title"},[_vm._v(" 下载完成，是否安装新版本？ ")]),_c('div',{staticClass:"about-footer"},[_c('div',{staticClass:"footer-button"},[_vm._v(" 稍后 ")]),_c('div',{staticClass:"footer-button now-version-button-red",on:{"click":function($event){return _vm.destoryedAndUpdate()}}},[_vm._v(" 关闭并更新 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }